module.exports = __webpack_public_path__ + "static/media/29EUNOG14.9611e423.jpg";